import { render, staticRenderFns } from "./beginTeacherTestMsgBox.vue?vue&type=template&id=610a0c35&scoped=true&"
import script from "./beginTeacherTestMsgBox.vue?vue&type=script&lang=js&"
export * from "./beginTeacherTestMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./beginTeacherTestMsgBox.vue?vue&type=style&index=0&id=610a0c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a0c35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
